import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import SearchIcon from '@material-ui/icons/Search';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import axios from '../utils/axios';
import Filter from '../../src/utils/filter';
import AutocompleteWithFormik from './AutocompleteWithFormik';
import { mainDefault } from '../utils/data-utils';
import Warning from './Warning';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  container: {
    padding: 0
  },
  paper: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0
    }
  },
  volverButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing()
  },
  buttonVerificar: {
    marginTop: theme.spacing(3)
  },
  categoria: {
    maxWidth: theme.spacing(100),
    margin: 'auto'
  }
});

// const defaultSelectObjValue = {
//   value: {},
//   label: ''
// };

const fieldIsRequired = 'validation.fieldIsRequired';
const validationSchema = Yup.object().shape({
  tipoDeServicio: Yup.object().shape({
    value: Yup.object().shape({
      id: Yup.number().required(fieldIsRequired)
    })
  })
});

const MainForm = ({ ...props }) => {
  const { classes, enqueueSnackbar, t, i18n } = props;
  const baseObject = { ...mainDefault };
  // const { i18n } = useTranslation();
  // const [baseObject, setBaseObject] = useState({ ...mainDefault });
  const urlVolver = queryString.parse(props.location.search).volver;
  const [tipoDeServicios, setTipodeServicios] = useState([]);
  const history = useHistory();
  const buildGetCallback = (errorMessage, callback) => {
    if (callback) {
      callback([]);
    }
    enqueueSnackbar(errorMessage, {
      variant: 'error'
    });
  };

  const reloadTipoDeServicio = () => {
    const params = { 
      filter: Filter.path('id').notEq(999999),
    };

    axios
      .get(`inversionistastiposervicio/filtrado?filtro=`, {
        data: {},
        params
      })
      .then(r => {
        if (i18n.language === 'es') {
          setTipodeServicios(
            r.data.map(d => ({
              value: d,
              label: `${d.descripcion}`
            }))
          );
        }
        if (i18n.language === 'en') {
          setTipodeServicios(
            r.data.map(d => ({
              value: d,
              label: `${d.descIngles}`
            }))
          );
        }
        if (i18n.language === 'pt') {
          setTipodeServicios(
            r.data.map(d => ({
              value: d,
              label: `${d.descPortugues}`
            }))
          );
        }
      })
      .catch(() => {
        buildGetCallback(
          'Error al obtener el listado de tipos de servicios',
          setTipodeServicios
        );
      });
  };

  useEffect(() => {
    reloadTipoDeServicio();
  }, i18n.language, [] );

  return (
    <div>
      <Container maxWidth="lg" className={classes.container}>
        <Warning />
        <Paper className={classes.paper} elevation={2}>
          {urlVolver && (
            <div className={classes.volverButton}>
              <Button
                type="button"
                variant="contained"
                color="primary"
                href={urlVolver}
              >
                Volver
              </Button>
            </div>
          )}
          <Formik
            enableReinitialize
            initialValues={baseObject}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              const url = `/registros?tipoDeServicioId=${
                values.tipoDeServicio.value.id
              }`;
              history.push(url);
            }}
          >
            {({
              isSubmitting,
              setFieldValue,
              values,
              handleBlur,
              handleChange,
              setFieldTouched,
              errors,
              touched,
              resetForm
            }) => (
              <Form noValidate>
                <Grid container justify="center" alignItems="center">
                  <Typography variant="h5" gutterBottom>
                    {t("main.title")}
                  </Typography>
                  <Grid item xs={12}>
                    <AutocompleteWithFormik
                      label={t("main.inputLabel")}
                      placeholder={t("main.placeholder")}
                      name="tipoDeServicio"
                      options={tipoDeServicios}
                      className={classes.categoria}
                      value={values.tipoDeServicio}
                      valueKey="value.id"
                      onChange={tipo => {
                        setFieldValue('tipoDeServicio', tipo || '');
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.buttonVerificar}
                      disabled={isSubmitting}
                    >
                      {t("main.searchButton")}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Paper>
        <br />
        <Grid container justify="center" alignItems="center">
          <Typography variant="h6" gutterBottom>
            {t('footer.title')}
          </Typography>
        </Grid>
        <br />
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} md={3}>
            <Card className={classes.root} variant="outlined">
              <CardContent align="center">
                <SearchIcon color="primary" />
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  {t('footer.search')}
                </Typography>
                <Typography variant="body2" component="p">
                  {t('footer.searchBody')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={1} />
          <Grid item xs={12} md={3}>
            <Card className={classes.root} variant="outlined">
              <CardContent align="center">
                <CheckBoxOutlinedIcon color="primary" />
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  {t('footer.find')}
                </Typography>
                <Typography variant="body2" component="p">
                  {t('footer.findBody')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={1} />
          <Grid item xs={12} md={3}>
            <Card className={classes.root} variant="outlined">
              <CardContent align="center">
                <PermContactCalendarOutlinedIcon color="primary" />
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  {t('footer.contact')}
                </Typography>
                <Typography variant="body2" component="p">
                  {t('footer.contactBody')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

MainForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withTranslation()(withSnackbar(withStyles(styles)(MainForm)));